import React from 'react';
import {connect, ConnectedProps} from 'react-redux';
import SimpleBar from 'simplebar-react';
import {IReduxStoreState} from '@src/@interfaces';
import Menu from './sidebar/Menu';
import classnames from '@src/helpers/classnames';
import {closeMobileSidebar} from '@src/_redux/theme/actions';
import HeaderLogo from './header/HeaderLogo';

const submenuProps = {
    menuClassName: 'sub-menu list-unstyled',
};

export class Sidebar extends React.Component<ConnectedProps<typeof connector>> {
    constructor(props: any) {
        super(props);

        this.clickListener = this.clickListener.bind(this);
        this.onSidebarClick = this.onSidebarClick.bind(this);
    }

    componentDidMount() {
        document.addEventListener('click', this.clickListener);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.clickListener);
    }

    render() {
        return <div className={classnames({
            'vertical-menu': true,
            'open': this.props.isMobileVersion && this.props.mobileSidebarOpen,
            'vertical-menu--collapsed': !this.props.isMobileVersion && this.props.desktopSidebarSize === 'small',
        })} onClick={this.onSidebarClick}>
            <div className="vertical-menu__logo-block">
                <HeaderLogo/>
            </div>

            <SimpleBar className="h-100 custom-simplebar">
                <div className="vertical-menu__wrapper">
                    <Menu
                            items={this.props.navigationItems ?? []}
                            openAllSubMenus={this.props.desktopSidebarSize === 'small'}
                            menuClassName="list-unstyled"
                            sectionItemClassName="vertical-menu__section-title"
                            itemBadgeClassName="badge"
                            submenu={submenuProps}
                    />
                </div>
            </SimpleBar>
        </div>;
    }

    protected clickListener() {
        if (this.props.isMobileVersion && this.props.mobileSidebarOpen) {
            this.props.closeMobileSidebar();
        }
    }

    protected onSidebarClick(e: React.MouseEvent) {
        const eventTarget: any = e.target;
        if (eventTarget instanceof HTMLLinkElement || eventTarget.closest && eventTarget.closest('a')) {
            return;
        }

        e.stopPropagation();
    }
}

export const connector = connect((state: IReduxStoreState) => ({
    navigationItems: state.navigation.sidebar,
    isMobileVersion: state.theme.isMobileVersion,
    desktopSidebarSize: state.theme.sidebar.desktop.size,
    mobileSidebarOpen: state.theme.sidebar.mobile.open,
}), {closeMobileSidebar});

export default connector(Sidebar);
